import { render, staticRenderFns } from "./config-data.vue?vue&type=template&id=c9e92b90&scoped=true&"
import script from "./config-data.vue?vue&type=script&lang=js&"
export * from "./config-data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9e92b90",
  null
  
)

export default component.exports